/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function ZipIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 9H9V8H10V7H9V6H10V5H9V4H10V3H9V2.01228L18.003 2.00223C19.1064 2.001 20.0023 2.89362 20.0052 3.99703L20.0156 8.01562V20.0156C20.0156 20.5469 19.8125 21.0078 19.4062 21.3984C19.0156 21.7891 18.5469 21.9844 18 21.9844H6C5.46875 21.9844 5 21.7969 4.59375 21.4219C4.1875 21.0312 3.98438 20.5625 3.98438 20.0156L4.03125 3.98438C4.03125 3.45312 4.21875 2.99219 4.59375 2.60156C4.98438 2.21094 5.45312 2.01562 6 2.01562L8 2.01339V3H7V4H8V5H7V6H8V7H7V8H8V9H7V12H10V9ZM8 2.01339L9 2.01228V2H8V2.01339ZM6 20V18.9072L9.00781 15.015H6V14H10.5312V14.9413L7.39453 18.9891H10.6523V20H6ZM11.3516 20V14H12.5078V20H11.3516ZM13.6133 14V20H14.7695V17.7367H15.5234C16.0469 17.7367 16.4466 17.708 16.7227 17.6508C16.9258 17.6044 17.125 17.5102 17.3203 17.3683C17.5182 17.2237 17.681 17.0259 17.8086 16.7749C17.9362 16.5239 18 16.2142 18 15.8458C18 15.3683 17.8893 14.9795 17.668 14.6794C17.4466 14.3765 17.1719 14.1801 16.8438 14.09C16.6302 14.03 16.1719 14 15.4688 14H13.6133ZM14.7695 16.7176V15.015H15.3281C15.7448 15.015 16.0221 15.0286 16.1602 15.0559C16.3477 15.0914 16.5026 15.1801 16.625 15.322C16.7474 15.4638 16.8086 15.6439 16.8086 15.8622C16.8086 16.0396 16.7643 16.1951 16.6758 16.3288C16.5898 16.4625 16.4701 16.5607 16.3164 16.6235C16.1628 16.6862 15.8581 16.7176 15.4023 16.7176H14.7695Z"
        fill="black"
      />
    </SvgIcon>
  );
}
